<template>
  <img
    :src="src"
    alt="Armoire Logo">
</template>

<script setup>
const src = `${import.meta.env.VITE_WEBSITE_IMAGES_URL}LogoType.svg`
</script>
